function SuccessMessage() {
  return (
    <div className="mb-6 rounded-2xl border border-green-200 bg-green-50 px-5 py-4 text-center text-sm font-semibold text-green-700">
      Your message has been sent successfully!
    </div>
  );
}

export default SuccessMessage;